export const ROBLOX_STUDIO_FILE_SEPARATOR = '='.repeat(78);

export type RobloxStudioBridgeFile = {
  id: 'server' | 'client';
  fileName: string;
  location: string;
  content: string;
};

export function parseRobloxStudioBridgeFiles(
  script: string,
): RobloxStudioBridgeFile[] {
  const trimmed = script.trim();
  if (!trimmed) {
    return [];
  }

  const headerRe = /\n?={78}\n-- FILE \d+ of \d+: ([^\n]+)\n={78}\n\n/g;
  const headers = [...trimmed.matchAll(headerRe)];
  if (headers.length === 0) {
    return [
      {
        id: 'server',
        fileName: 'ValvurPatrolBridge.server.lua',
        location: 'ServerScriptService',
        content: trimmed,
      },
    ];
  }

  const files: RobloxStudioBridgeFile[] = [];
  for (let index = 0; index < headers.length; index += 1) {
    const header = headers[index];
    const location = header[1].trim();
    const fileName = location.includes('>')
      ? location.split('>').pop()!.trim()
      : location;
    const contentStart = (header.index ?? 0) + header[0].length;
    const contentEnd =
      index + 1 < headers.length ? headers[index + 1].index! : trimmed.length;
    const content = trimmed.slice(contentStart, contentEnd).trim();
    files.push({
      id: fileName.includes('.client.') ? 'client' : 'server',
      fileName,
      location,
      content,
    });
  }

  return files;
}
